import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import useKeyboardNavigation from "../../../../utils/useKeyboardNavigation";
import { handleDownloadCSV } from "../../../../utils/CsvDownload";

const Table = ({ setselected_item_data, list_data, po_status, setRows, rows, setError,setptype,setShowError }) => {
  const createNewRow = () => ({
    item_code: "",
    item: {},
    required_by: "",
    quantity: 1,
    uom: "",
    rate: "0",
    amount: "0",
  });

  const tableRef = useRef();
  const dropdownRef = useRef();
  const [rowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [item_list, setitem_list] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);


  const [search_input, setsearch_input] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

  // const handleSelectAll = (e) => {
  //   if (e.target.checked) {
  //     const allRowIndices = rows.map((_, index) => index);
  //     setSelectedRows(allRowIndices);
  //   } else {
  //     setSelectedRows([]);
  //   }
  // };

    const handleSelectAll = (e) => {
    if (e.target.checked) {
      // Only select rows in the current page
      const pageRowIndices = rows
        .map((_, index) => index)
        .slice(indexOfFirstRow, indexOfLastRow);

      setSelectedRows((prev) => [...new Set([...prev, ...pageRowIndices])]);
    } else {
      // Deselect only the current page rows
      const pageRowIndices = rows
        .map((_, index) => index)
        .slice(indexOfFirstRow, indexOfLastRow);

      setSelectedRows((prev) => prev.filter((i) => !pageRowIndices.includes(i)));
    }
  };

  
  const { focusedCellkey, setFocusedCellkey } = useKeyboardNavigation(rows.length);
  
  const getItemdata = async (newOffset = 0, searchText = "") => {
    const res = await list_data({ start: newOffset, search_input: searchText, disabled: 0 });
    const products = res?.data?.result?.products || [];
    if (newOffset === 0) {
      setitem_list(products);
    } else {
      setitem_list((prev) => [...prev, ...products]);
    }
    setHasMore(products.length === 20);
  };

  const updateRow = (index, field, value) => {
    const updatedRows = [...rows];    
    
    if(field === "quantity"){
      if(parseInt(value) > updatedRows[index].totalqty){
          setptype("Error");
          // setError('Quantity cannot be greater than available stock.');
          setError(`Quantity cannot be greater than available stock (${updatedRows[index].totalqty}).`);
          setShowError(true);
          return;
      }
    }


    updatedRows[index][field] = value;
    if (field === "quantity" || field === "rate") {
      const quantity = parseFloat(updatedRows[index].quantity) || 0;
      const rate = parseFloat(updatedRows[index].rate) || 0;
      updatedRows[index].amount = (quantity * rate).toFixed(2);
    }
    
    setRows(updatedRows);
    setselected_item_data(updatedRows);
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) => prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]);
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    setselected_item_data(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }

    if(updatedRows.length == 0){
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    getItemdata(0, "");
  }, []);

  useEffect(() => {
    const dropdown = dropdownRef.current;
    if (!dropdown) return;
    const handleScroll = () => {
      if (dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 && hasMore) {
        const newOffset = offset + 20;
        setOffset(newOffset);
        getItemdata(newOffset, search_input);
      }
    };
    dropdown.addEventListener("scroll", handleScroll);
    return () => dropdown.removeEventListener("scroll", handleScroll);
  }, [offset, hasMore, search_input]);

  useEffect(() => {
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div className="">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {["Action", "S.No", "Item Code", "Item Name","category" ,"Sub category" , "Quantity", "UOM", "Rate", "Amount"].map((title, i) => {
              const defaultWidths = {
                "Action": "20px",
                "S.No": "20px",
                "Item Code": "15%",
                "Item Name": "15%",
                "category": "15%",
                "Sub category":"15%",
                "Quantity": "7%",
                "UOM": "6%",
                "Rate": "10%",
                "Amount": "10%",
              };

              return (
                <th
                  key={i}
                  style={{
                    fontSize: '7px',
                    position: "relative",
                    textAlign: title === "Action" || title === "S.No" ? "center" : "center",
                    width: defaultWidths[title] || "150px",
                    minWidth: defaultWidths[title] || "150px",
                  }}
                >
                  {title === "Action" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{ backgroundColor: isAllSelected ? "#270b79" : "", borderColor: isAllSelected ? "#270b79" : "", fontSize: '15px' }}
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  ) : (
                    title
                  )}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            const calculatedAmount = (parseFloat(row.quantity || 0) * parseFloat(row.rate || 0)).toFixed(2);
            
            return (
              <tr key={globalIndex} style={{ height: '30px' }}>
                <td className="p-0" style={{ cursor: 'pointer' }}>
                  <p className="m-0" style={{ position: 'relative', top: "5px" }}>
                    {selectedRows.includes(globalIndex) ? (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ backgroundColor: "#270b79", fontSize: '15px', borderColor: '#270b79' }}
                          checked
                        />
                      </span>
                    ) : (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input type="checkbox" className="form-check-input" style={{ fontSize: '15px' }} />
                      </span>
                    )}
                  </p>
                </td>
                <td className="p-0" style={{
                  textAlign: "center",
                  fontSize: '0.8rem',
                  lineHeight: '29px'
                }}>
                  {globalIndex + 1}
                </td>
                <td className="p-0 d-flex justify-content-center" style={{ position: "relative", border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'item_code' ? '0.3px solid #270b79' : '' }}>
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', height: '28.4px', textAlign: 'center' }}
                    onFocus={() => { setShowDropdown(globalIndex); setFocusedCell({ rowIndex: globalIndex, field: 'item_code' }); }}
                    onBlur={() => { setTimeout(() => setShowDropdown(false), 300) }}
                    onChange={(e) => {
                      if(!row.item?.item_code){
                        setsearch_input(e.target.value);
                        setOffset(0);
                        getItemdata(0, e.target.value);
                        updateRow(globalIndex, "item_code", e.target.value);
                      }
                    }}
                    value={row.item.item_code || row.item_code}

                  />
                  <div
                    ref={dropdownRef}
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      maxHeight: showDropdown === globalIndex ? "200px" : "0",
                      display: showDropdown === globalIndex && !row?.item?.item_code ? '' : 'none',
                      overflowY: "auto",
                      background: "white",
                      border: showDropdown === globalIndex ? "1px solid #ccc" : "",
                      zIndex: 10,
                    }}
                  >
                    {item_list.map((item, idx) => (
                      <div key={idx}
                        className="text-start"
                        onClick={() => {
                          updateRow(globalIndex, "item", item);
                          updateRow(globalIndex, "item_code", item.item_code);
                          // Set the rate from the item's buying_price if available
                          if (item.buying_price) {
                            updateRow(globalIndex, "rate", item.buying_price);
                          }
                          setsearch_input("");
                          setShowDropdown(false);
                        }}
                        style={{
                          padding: "8px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                      >
                        <p className="m-0">
                          {item.item_code}
                        </p>
                        <div style={{ fontSize: '10px' }}>
                          {item?.item_name}, {item?.item_group}
                        </div>
                      </div>
                    ))}
                    {!hasMore && item_list.length === 0 && (
                      <div style={{ padding: "8px", color: "#888" }}>No results</div>
                    )}
                  </div>
                </td>
                <td className="p-0"><input type="text" className=" p-0 form-control tableinput noborder" style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }} readOnly value={row.item.item_name} /></td>
                <td className="p-0"><input type="text" className=" p-0 form-control tableinput noborder" style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }} readOnly value={row.item?.item_group} /></td>
                <td className="p-0"><input type="text" className=" p-0 form-control tableinput noborder" style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }} readOnly value={row.item?.custom_category} /></td>
                <td className="p-0 d-flex justify-content-center" style={{ border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'quantity' ? '0.3px solid #270b79' : '' }} >
                  <input
                    type="tel"
                    className=" p-0 form-control tableinput noborder"
                    data-rowindex={globalIndex}
                    data-field={"quantity"}
                    style={{ fontSize: '0.8rem', textAlign: 'center', height: '28px' }}
                    min={1}
                    onFocus={() => { setFocusedCell({ rowIndex: globalIndex, field: 'quantity' }); setFocusedCellkey({ rowIndex: globalIndex, field: 'quantity' }) }}
                    onBlur={() => { setFocusedCell({ rowIndex: null, field: null }); setFocusedCellkey({ rowIndex: null, field: null }); }}
                    value={row.item.item_code ? row.quantity : ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        updateRow(globalIndex, "quantity", value);
                      }
                    }}
                  />
                </td>
                <td className="p-0"><input type="text" className=" p-0 form-control tableinput noborder" style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }} readOnly value={row.item.stock_uom} /></td>
                <td className="p-0 d-flex justify-content-center" style={{ border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'rate' ? '0.3px solid #270b79' : '' }}>
                  <input
                    type="text"
                    className="p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', height: '28px' }}
                    value={focusedCell.rowIndex === globalIndex && focusedCell.field === 'rate' ? row.rate : `₹${row.rate}`}
                    data-rowindex={globalIndex}
                    data-field={"rate"}
                    onFocus={() => {setFocusedCell({ rowIndex: globalIndex, field: 'rate' });setFocusedCellkey({ rowIndex: globalIndex, field: 'rate' })}}
                    onBlur={() => {setFocusedCell({ rowIndex: null, field: null });setFocusedCellkey({ rowIndex: null, field: null });}}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow numbers and decimal points
                      if (/^\d*\.?\d*$/.test(value)) {
                        updateRow(globalIndex, "rate", value);
                      }
                    }}
                  />
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className="p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row.item.item_code ? `₹${parseInt(calculatedAmount)}` : ''}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
          {selectedRows.length > 0 && po_status == '' && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn "
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}
       
          
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>

      

      </div>
    </div>
  );
};

export default Table;